import LazyLoad from 'react-lazyload'
import React from 'react'
import PropTypes from 'prop-types'

import Play80Icon from '../../../assets/codicons/play-80'
import Play150Icon from '../../../assets/codicons/play-150'

const ItemTileCover = props => {
  let renderProductCategory = () => {
    if (props.primaryCategory && props.primaryCategory.title !== '') {
      return (
        <div className='product-category'>
          <span className='category-label'>{props.primaryCategory.title}</span>
        </div>
      )
    } else {
      return null
    }
  }

  let renderBundleTag = () => {
    if (props.type === 'Bundle') {
      return <div className='product-bundle-tag'>Bundle</div>
    }
  }

  let playIcon

  if (props.includePlayIcon) {
    playIcon = (
      <React.Fragment>
        <div className='black-overlay' />
        <div className='play-icon-container'>
          <div className='hidden-xs'>
            <Play150Icon />
          </div>
          <div className='visible-xs'>
            <Play80Icon />
          </div>
        </div>
      </React.Fragment>
    )
  }

  let completedIcon
  if (props.completedIcon) {
    completedIcon = props.completedIcon()
  }

  return (
    <a href={props.itemUrl} className='product-cover-container'>
      <LazyLoad height='100%' once offset={500}>
        <img className='plan-cover product-cover' src={props.coverPhoto} />
      </LazyLoad>
      <div className='product-badges'>
        {renderProductCategory()}
        {renderBundleTag()}
      </div>
      {playIcon}
      {completedIcon}
      {props.metaDataComp}
    </a>
  )
}

ItemTileCover.defaultProps = {
  includePlayIcon: false
}

ItemTileCover.propTypes = {
  completedIcon: PropTypes.func,
  coverPhoto: PropTypes.string,
  primaryCategory: PropTypes.object,
  itemUrl: PropTypes.string,
  includePlayIcon: PropTypes.bool,
  type: PropTypes.string,
  metaDataComp: PropTypes.node
}

export default ItemTileCover
